import { useEffect } from "react";
import {
    FormControl,
    Typography,
    InputLabel,
    Select,
    MenuItem,
    Box,
    Button,
    CircularProgress
} from "@mui/material";
import { useForm } from "react-hook-form";
import StyledTextArea from "../../themes/overrides/TextArea";

const ImageGenerationPanel = ({ generativeModels, selectedGenerativeModel, setSelectedGenerativeModel, handleGenerateContent, AIPrompt, setAIPrompt, selectedStyle, setSelectedStyle, aiLoading }) => {
    const { register, formState: { errors } } = useForm();
    const vyroStyles = [
        {
            name: "Realistic", value: "realistic", description: "Best for achieving highly detailed, lifelike images with intricate textures and lighting."
        },
        { name: "Anime", value: "anime", description: "Perfect for creating vibrant, expressive artwork with a Japanese animation flair." },
        { name: "Flux Schnell", value: "flux-schnell", description: "Optimized for fast image generation with high detail and quality." },
        { name: "Flux Dev Fast", value: "flux-dev-fast", description: "A development-focused style with faster rendering times." },
        { name: "Flux Dev", value: "flux-dev", description: "A versatile style designed for development and experimentation." },
        { name: "Imagine Turbo", value: "imagine-turbo", description: "Balances rapid image generation with flexible results." },
    ]

    useEffect(() => {
        setSelectedStyle(vyroStyles[0]?.value)
    }, [])

    return (
        <>
            <FormControl sx={{ mt: 1 }} variant="standard" fullWidth>
                <Typography
                    sx={{
                        fontSize: '0.9rem',
                        color: 'black',
                        fontWeight: 400,
                        mb: 1
                    }}
                >
                    Enter prompt
                </Typography>
                <StyledTextArea
                    {...register('AIPrompt', { required: "Prompt is required" })}
                    value={AIPrompt}
                    onChange={(e) => setAIPrompt(e.target.value)}
                    sx={{
                        '& .MuiInputBase-input.Mui-disabled': {
                            WebkitTextFillColor: 'black',
                            color: 'black',
                        },
                    }}
                />
            </FormControl>

            <Box gap={2} sx={{ display: 'flex' }}>
                <FormControl fullWidth sx={{ mt: 2 }}>
                    <InputLabel sx={{ fontSize: "1rem", color: "gray" }}>Generative Model</InputLabel>
                    <Select
                        value={selectedGenerativeModel?.model || ''}
                        onChange={(e) => setSelectedGenerativeModel(generativeModels.find(model => model.model === e.target.value))}
                        label="Generative Model"
                        sx={{
                            fontSize: "1.1rem",
                            color: "#333",
                            height: '55px',
                            '& .MuiSelect-select': { paddingTop: '6px', paddingBottom: '6px' }
                        }}
                    >
                        {
                            generativeModels.length > 0 ? (
                                generativeModels.map((model) => (
                                    <MenuItem key={model.model} value={model.model} sx={{ fontSize: "1.1rem" }}>
                                        {model.model}
                                    </MenuItem>
                                ))
                            ) : (
                                <Typography sx={{ fontSize: "1.1rem", color: "gray", mt: 2 }}>No models available</Typography>
                            )
                        }
                    </Select>
                </FormControl>

                {selectedGenerativeModel?.model === 'vyro' && (
                    <FormControl fullWidth sx={{ mt: 2 }}>
                        <InputLabel sx={{ fontSize: "1rem", color: "gray" }}>Style</InputLabel>
                        <Select
                            value={selectedStyle || ''}
                            onChange={(e) => {
                                setSelectedStyle(e.target.value)
                            }}
                            label="Generative Model"
                            sx={{
                                fontSize: "1.1rem",
                                color: "#333",
                                height: '55px',
                                '& .MuiSelect-select': { paddingTop: '6px', paddingBottom: '6px' }
                            }}
                        >

                            {vyroStyles.map((style) => (
                                <MenuItem
                                    key={style.value}
                                    value={style.value}
                                    sx={{
                                        fontSize: "1rem",
                                        borderRadius: "8px",
                                        padding: "10px",
                                        "&:hover": { backgroundColor: "#f5f5f5" }
                                    }}
                                >
                                    <Box>
                                        <Typography sx={{ fontSize: "1rem", color: "black" }}>
                                            {style.name}
                                        </Typography>
                                        <Typography sx={{ fontSize: "0.85rem", color: "gray" }}>
                                            {style.description}
                                        </Typography>
                                    </Box>
                                </MenuItem>
                            ))}

                        </Select>
                    </FormControl>
                )}

                <Button
                    sx={{ width: 200, mt: 2, py: 2 }}
                    disabled={!selectedGenerativeModel || !AIPrompt || aiLoading}
                    variant="contained"
                    onClick={handleGenerateContent}
                >
                    {!aiLoading ? (
                        'Generate'
                    ) : (
                        <CircularProgress size={24} />
                    )}
                </Button>
            </Box>
        </>
    );
};

export default ImageGenerationPanel;
